<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg10 sm12>          
            <v-card pa-0>   
              <v-toolbar v-bind:color="kompetisi ? kompetisi.color : 'white'" dark flat dense cad>                                              
                <v-toolbar-title class="subheading">CALON {{kompetisi ? kompetisi.name : null}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="form-btn">
                  <v-btn v-if="!isUpdate" @click="save(isUpdate)" v-bind:loading="loading" outline>Create</v-btn>
                  <v-btn v-else @click="save(isUpdate)" v-bind:loading="loading" outline>Update</v-btn>                                                                                          
                </div>                                                                     
                <v-menu bottom left>
                  <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                  <v-list>                    
                    <v-list-tile v-bind:to="{path:'/calon/', query:$route.query}">
                      <v-list-tile-title>Index</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="isUpdate" v-on:click="remove()">
                      <v-list-tile-title>Delete</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-card-text class="">
                <v-form v-model="valid">
                  <v-layout row wrap>
                    <v-flex lg5 sm6 xs12>
                      <v-layout>
                        <v-flex xs4>
                          <v-text-field
                            box
                            label="No"
                            name="no"                              
                            v-model="formModel.no"
                            v-validate="'required'"
                            data-vv-name="no"     
                            v-bind:error-messages="errors.collect('no')"  
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field
                            box
                            label="Akronim"
                            name="akronim"                              
                            v-model="formModel.akronim"
                            v-validate="'required'"
                            data-vv-name="akronim"     
                            v-bind:error-messages="errors.collect('akronim')"  
                            required
                          ></v-text-field>
                        </v-flex>                    
                      </v-layout>

                      <v-text-field
                        box
                        label="Name"
                        name="name"                              
                        v-model="formModel.name"
                        v-validate="'required'"
                        data-vv-name="name"     
                        v-bind:error-messages="errors.collect('name')"  
                        required
                      ></v-text-field>

                      <v-text-field
                        box
                        label="Tagline"
                        name="tagline"                              
                        v-model="formModel.tagline"
                        v-validate="'required'"
                        data-vv-name="tagline"     
                        v-bind:error-messages="errors.collect('tagline')"  
                        required
                      ></v-text-field>

                      <v-switch 
                        v-bind:label="formModel.status === 1 ? 'Status Active' : 'Status Inactive'" 
                        v-bind:true-value="1"
                        v-bind:false-value="0"
                        v-model="formModel.status">                      
                      </v-switch>                                    

                      <v-textarea
                        box
                        label="Description"                                                  
                        v-model="formModel.desc"                      
                      ></v-textarea> 

                      <slider-picker v-model="colors" style="width:100%" />
                      <v-text-field v-model="formModel.color" label="Color" class="mt-2" solo></v-text-field>

                    </v-flex>
                    <v-flex lg7 sm6 xs12>
                      <span class="subheading">Partai Koalisi</span>
                      <v-divider></v-divider>
                      <v-alert v-if="alert" v-bind:value="alert.status" color="warning" icon="priority_high" dark>
                        {{alert.msg}}
                      </v-alert>
                      <div class="v-table__overflow" v-click-outside="notMagic">
                        <v-btn @click="newDtl()" icon class="primary--text mb-2" style="position: absolute; right:10px; " ><v-icon>add</v-icon></v-btn>                
                        <v-data-table
                            :headers="headersDtl"
                            :items="formModel.partolons"
                            :loading="loading"
                            hide-actions
                            class="elevation-1"                         
                        >                                
                          <v-progress-linear slot="progress" color="blue" v-if="loading" indeterminate></v-progress-linear>                             
                          <template slot="items" slot-scope="props" >
                            <td @click="isMagic(props)" style="width:0%">{{props.index+1}}</td>
                            <td @click="isMagic(props)">
                              <v-autocomplete
                                solo hide-details
                                v-bind:items="partais"
                                v-bind:filter="customFilter"                      
                                item-text="akronim"
                                item-value="id"
                                v-model="props.item.partai_id"
                                label="Partai ID"
                                v-bind:error-messages="errors.collect('partai_id')" 
                                v-validate="'required'"
                                data-vv-name="partai_id" 
                                required
                                v-if="props.item.magic"
                                hide-no-data clearable                      
                              ></v-autocomplete>   
                              <span class="results-as-you-type" v-else>
                                {{namePartai(props.item.partai_id)}} 
                              </span>                              
                            </td>                            
                            <td class="text-xs-right">                                    
                              <v-btn v-on:click="delDtl(props)" icon class="pink--text" small>
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>                                
                          </template>
                        </v-data-table> 
                      </div>
                    </v-flex>
                  </v-layout>                                                                                        
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Calon';    
import {Slider} from 'vue-color';
import direct from '@/util/directives';

var model = new Model();

export default {
    directives : direct,
    components: {
      'slider-picker': Slider,
    },
    $_veeValidate: {
        validator: 'new'
    },    
    asyncComputed: { 
      kompetisi(){
        this.loading = true;
        this.formModel.kompetisi_id = this.$route.query.kompetisi_id;
        return model.kompetisi({id:this.formModel.kompetisi_id}).then(res=>{
          this.loading = false; 
          return res;
        });
      },     
    },    
    data: () => ({
        isEditing:true,
        isUpdate:false,
        formModel: {          
          id : null,
          no : null,
          name : null,
          akronim : null,
          tagline : null,
          desc : null,
          color: '#ffffff',
          status : 1,      
          kompetisi_id : null,
          partolons:[]
        },
        headersDtl:[
          {text:'No', value:'no', sortable: false},
          {text:'Partai', value:'partai_id', sortable: false},
          {text:'', value:'action',sortable: false},
        ],
        status: [],
        partais: [],
        colors:{hex:'#FFFFFF'},
        valid: true,
        loading : false,
        alert: null
    }),
    watch:{
      formModel:{
        handler(newVal){
          this.colors = {hex:newVal.color};
        },
        deep:true
      },
      colors(newVal){this.formModel.color = newVal.hex;}
    },
    created () {
      model.partais().then(res=>{
        this.partais = res;
      });
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true; this.loading=true;
                model.one({id : this.$route.query.id }).then(data => {                     
                    Object.assign(this.formModel, data === null ? {}:data); 
                    this.formModel.partolon.forEach((item,i)=>{this.newDtl(item, i);});                    
                    this.checking(data); this.loading=false;                    
                });                                               
            }
            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = this.$moment().valueOf();
            this.formModel.info = null;
            if( !this.errors.any() ) { this.loading = true;
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                } this.loading = false;
            }             
        },
        
        remove(){
          this.$swal({
              title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',
              showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
          }).then((result) => {                 
              if (result.value) { this.loading = true;                   
                model.delete(this.formModel).then( res => {
                  if(res.status === 200){                   
                      this.$swal('Deleted!', 'Your file has been deleted.', 'success');       
                      this.$route.query.id = null;
                      this.$router.push({path:'/calon/', query:this.$route.query}); 
                  } else {
                      var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                      var text  = res.statusText ? res.statusText:
                          'Something happened in setting up the request that triggered an Error.'; 
                      this.$swal({type: 'error', title: title, text: text});                                        
                  } this.loading = false;
                });              
              }
          });
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },   
        
        namePartai(id){
          let name; this.partais.forEach((item)=>{
            if(item.id === id)name=item.akronim;
          }); return name;
        },
        
        newDtl(d = null, i = null){
          this.notMagic();               
          
          this.formModel.partolons.push({        
            id : d ? d.id : null,
            partai_id : d ? d.partai_id : null,
            calon_id : this.formModel.id ,
            magic : true,        
          });                      
          
          this.no++;
        },
        
        delDtl(props){            
          this.formModel.partolons.splice(props.index, 1);   
          //this.detail.splice(props.index, 1);   
        }, 

        isMagic(props){     
          props.item.magic = true;
          this.notMagic(props.index);            
        },

        notMagic(exc = null){
          this.formModel.partolons.forEach((item, index)=>{
            if(exc !== index){
              this.formModel.partolons[index].magic = false;
            }
          });               
        }
    }
}
</script>